import { AccountMenu } from "@/components/layout/AccountMenu";
import { AppLayout } from "@/components/layout/AppLayout";
import {
  NavigationMenu,
  NavigationMenuHeader,
  NavigationMenuHeading,
  NavigationMenuLink,
} from "@/components/layout/NavigationMenu";
import { MoneyFnsProvider } from "@/modules/money-fns";
import { checkAdminRole, checkAuth } from "@/utils/router";
import { seo } from "@/utils/seo";
import { ChevronLeftIcon, ProhibitedIcon, SendMailIcon, StickyNoteIcon, UsersIcon } from "@givenwell/core-solid-icons";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/campaigns")({
  beforeLoad: async () => {
    await checkAuth();
    await checkAdminRole();
  },
  component: Layout,
  head: () => ({
    meta: seo({ title: "Campaigns" }),
  }),
});

function Layout() {
  return (
    <MoneyFnsProvider>
      <AppLayout
        role="admin"
        sidebar={
          <NavigationMenu header={<NavigationMenuHeader />} footer={<AccountMenu role="admin" />}>
            <NavigationMenuLink to="/admin" icon={<ChevronLeftIcon />}>
              Back to admin
            </NavigationMenuLink>
            <NavigationMenuHeading>Campaigns</NavigationMenuHeading>
            <NavigationMenuLink to="/campaigns/templates" icon={<StickyNoteIcon />}>
              Templates
            </NavigationMenuLink>
            <NavigationMenuLink to="/campaigns/segments" icon={<UsersIcon />}>
              Segments
            </NavigationMenuLink>
            <NavigationMenuLink to="/campaigns/sends" icon={<SendMailIcon />}>
              Sends
            </NavigationMenuLink>
            <NavigationMenuLink to="/campaigns/unsubscribed" icon={<ProhibitedIcon />}>
              Unsubscribed
            </NavigationMenuLink>
          </NavigationMenu>
        }
      >
        <Outlet />
      </AppLayout>
    </MoneyFnsProvider>
  );
}
